import { formatUSD } from "../../lib/format";

/* eslint-disable @typescript-eslint/no-explicit-any */
// Shared Recharts tooltip rendering money values in USD.
export function MoneyTooltip({ active, payload, label }: any) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-ink-200 bg-white p-2 text-xs shadow-card">
      {label !== undefined && label !== "" && (
        <div className="mb-1 font-semibold text-ink-700">
          {typeof label === "number" ? `Week ${label}` : label}
        </div>
      )}
      {payload.map((p: any) => (
        <div key={p.name} className="flex items-center justify-between gap-3">
          <span className="flex items-center gap-1.5 text-ink-600">
            <span className="h-2 w-2 rounded-full" style={{ background: p.color }} />
            {p.name}
          </span>
          <span className="font-medium tabular-nums text-ink-900">{formatUSD(p.value)}</span>
        </div>
      ))}
    </div>
  );
}
